import { React, useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { FaDownload } from "react-icons/fa";
import { BsPinFill } from "react-icons/bs";
import Aos from "aos";
import "aos/dist/aos.css";

function LatestUpdates() {
	const [notices, setNotices] = useState([]);
	useEffect(() => {
		Aos.init({ duration: 1200 });
	}, []);

	useEffect(() => {
		axios
			.post("/api/notices/getNoticeListClient", {
				pageno: "1",
			}, {
				responseType: 'text' // Handle HTML prefix manually
			})
			.then((res) => {
				let data = res.data;
				try {
					const firstBrace = data.indexOf("{");
					const lastBrace = data.lastIndexOf("}");
					if (firstBrace !== -1 && lastBrace !== -1) {
						data = JSON.parse(data.substring(firstBrace, lastBrace + 1));
					}
				} catch (e) {
					console.log("JSON Parse Error", e);
				}
				setNotices(data.results || []);
			})
			.catch((err) => {
				console.log(err);
			});
	}, []);

	return (
		<>
			<div className="LatestUpdatesContainer">
				<div id="Heading" data-aos="fade-up">
					<h1>Latest Updates</h1>
				</div>

				<div className="UpdatesAndBanner">
					<div className="NoticeContainer" data-aos="fade-up">
						{notices && notices.map((notice) => (
							<Link
								key={notice.id}
								to={"https://vbumcaapi.vbumca.in" + notice.file_location}
								target="_blank"
								rel="noreferrer"
							>
								<div className="NoticeCard" data-aos="fade-up">
									<div className="NoticeCardLeft">
										<div className="NoticeTitle">
											<span className="pin-icon">
												<BsPinFill />
											</span>
											<span>{notice.title}</span>
										</div>
										<div className="NoticeDate">
											<span>
												{notice.updated_at ? new Date(notice.updated_at).toDateString() : ""}
											</span>
										</div>
									</div>
									<div className="NoticeCardRight">
										<span className="download-icon">
											<FaDownload />
										</span>
									</div>
								</div>
							</Link>
						))}
						<div className="viewAll" data-aos="fade-up">
							{notices && notices.length > 0 && <Link to="/allNotice">View All</Link>}
						</div>
					</div>
					
					<div className="BannerContainer" data-aos="fade-up">
						<img src="/Images/admissionbanner.jpeg" alt="Admission Banner" />
					</div>
				</div>
			</div>
		</>
	);
}

export default LatestUpdates;
